

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';

import { MwcValidateStatus } from 'mwc/core/types';

const iconTypeMap = {
  error: 'close-circle-fill',
  validating: 'loading',
  success: 'check-circle-fill',
  warning: 'exclamation-circle-fill'
} as const;

@Component({
  selector: 'mwc-form-item-feedback-icon',
  exportAs: 'mwcFormFeedbackIcon',
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <span *ngIf="iconType" mwc-icon [mwcType]="iconType"></span> `,
  host: {
    class: 'mwc-form-item-feedback-icon',
    '[class.mwc-form-item-feedback-icon-error]': 'status==="error"',
    '[class.mwc-form-item-feedback-icon-warning]': 'status==="warning"',
    '[class.mwc-form-item-feedback-icon-success]': 'status==="success"',
    '[class.mwc-form-item-feedback-icon-validating]': 'status==="validating"'
  }
})
export class MwcFormItemFeedbackIconComponent implements OnChanges {
  @Input() status: MwcValidateStatus = '';
  constructor(public cdr: ChangeDetectorRef) {}

  iconType: typeof iconTypeMap[keyof typeof iconTypeMap] | null = null;

  ngOnChanges(_changes: SimpleChanges): void {
    this.updateIcon();
  }

  updateIcon(): void {
    this.iconType = this.status ? iconTypeMap[this.status] : null;
    this.cdr.markForCheck();
  }
}
